
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2972',
  depVersions: {
  "customer-portal-app": "static-1.2972",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9880",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26023",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5817",
  "hs-test-utils": "static-1.8247",
  "hub-http": "static-1.6436",
  "hub-http-shared-msw-handlers": "static-1.10485",
  "hubspot-dlb": "static-2.1877",
  "hubspot-prosemirror": "static-1.18852",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11703",
  "I18n": "static-7.1652",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6671",
  "payment-link-components": "static-1.24034",
  "portals-platform-bend-plugin": "static-1.13",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7330",
  "quartz-core": "static-1.6549",
  "quartz-i18n": "static-1.1005",
  "react": "static-7.190",
  "react-colorpicker": "static-2.10429",
  "react-dlb": "static-1.84",
  "react-utils": "static-2.5495",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20200",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18293",
  "ui-components-test-utils": "static-1.5840",
  "UIComponents": "static-3.8649",
  "foundations-assets": "static-1.5097",
  "foundations-components": "static-1.8347",
  "foundations-theming": "static-1.4674",
  "foundations-theming-specialty": "static-1.2390",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9849",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1331",
  "quartz-config": "static-1.1108",
  "quartz-routing": "static-1.760",
  "quick-fetch": "static-1.4071",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-redact-emails-from-unexpected-route-pathname.6",
  "rpc-client-utils": "static-1.4884",
  "sanitize-text": "static-1.8371",
  "styled-components": "static-2.94",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4978",
  "ui-addon-react-router-dom": "static-1.9755",
  "usage-tracker": "static-1.7579",
  "usage-tracker-anonymous": "static-1.5996",
  "usage-tracker-core": "static-1.7429",
  "video-components-external": "static-1.11995",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3554",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3607",
  "quartz-webpack": "static-1.3554",
  "bend-plugin-quartz-routing": "static-1.408",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7906",
  "frontend-preferences-client": "static-1.8150",
  "laboratory-lib": "static-3.7374",
  "onboarding-scopes": "static-1.6681",
  "seat-types-lib": "static-1.551",
  "ui-addon-opt": "static-4.8584",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3358",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.234",
  "ts-schema": "static-1.4232",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8100",
  "content-media-capture": "static-1.5229",
  "cssUtils": "static-1.857",
  "customer-data-ui-utilities": "static-1.10048",
  "file-manager-components": "static-1.24299",
  "HubStyle": "static-2.12010",
  "knowledge-content-types": "static-1.8614",
  "PatternValidationJS": "static-1.3119",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.492",
  "ui-addon-emoji-picker": "static-1.10108",
  "ui-addon-i18n": "static-1.11368",
  "ui-business-units-lib": "static-1.9303",
  "ui-shepherd-react": "static-3.10484",
  "video-data-lib": "static-1.35653",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4541",
  "commerce-tours-lib": "static-1.6500",
  "customer-data-properties": "static-1.52360",
  "getting-started-shared-tasks": "static-1.19063",
  "growth-onboarding-reliability": "static-1.5302",
  "onboarding-tours": "static-1.17005",
  "reference-resolvers-lite": "static-1.8321",
  "sales-checkout-service-client": "static-1.3758",
  "ui-addon-iframeable": "static-1.9298",
  "user-context": "static-1.5335",
  "bender-build-tools": "static-1.3347",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4803",
  "icons": "static-2.671",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1005",
  "quartz-head": "static-1.995",
  "quartz-test": "static-1.1005",
  "quartz-tracking": "static-1.709",
  "trellis-components": "static-1.2414",
  "ui-fonts": "static-1.965",
  "usage-tracker-container": "static-1.7569",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9648",
  "data-token-picker": "static-1.16783",
  "FileManagerLib": "static-1.39939",
  "property-translator": "static-1.5617",
  "atom": "static-1.5298",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6254",
  "salesImages": "static-1.530",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5830",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.103",
  "ui-images": "static-2.1219",
  "bend-plugin-foundations-components": "static-1.4616",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2395",
  "bend-plugin-foundations-theming": "static-1.3157",
  "foundations-theming-base": "static-1.3659",
  "stylex": "static-1.37",
  "interframe": "static-3.4977",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5993",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.294",
  "chirp-fetch": "static-1.2110",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4698",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4879",
  "content-media-composition-data-lib": "static-1.13033",
  "content-media-compositions": "static-2.17040",
  "idb-keyval": "static-1.47",
  "immer": "static-1.94",
  "immerable": "static-1.4372",
  "magpie-lib": "static-1.5705",
  "magpie-types": "static-1.5165",
  "media-bridge-lib": "static-1.19302",
  "inbound-db-properties-service-client": "static-1.3999",
  "superstore": "static-1.4979",
  "feedback-loader": "static-1.29698",
  "ai-components-ui-library": "static-1.9530",
  "ui-addon-video-player": "static-1.8928",
  "ui-coaching-tips": "static-1.29168",
  "ContentUtils": "static-1.69003",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4647",
  "sassPrefix": "static-1.161",
  "react-dnd-compat": "static-1.4838",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1513",
  "copilot-toolkit": "static-1.11697",
  "avatar-components": "static-1.2720",
  "navigation-messaging": "static-1.8006",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8404",
  "commerce-products-lib": "static-1.10352",
  "crm-message-bus": "static-1.43583",
  "growth-data-modal": "static-1.5784",
  "hubspot-apollo-client": "static-1.5099",
  "onboarding-tours-client": "static-1.5219",
  "batch-promise": "static-1.1767",
  "calling-global-api": "static-1.65286",
  "calling-internal-common": "static-1.31538",
  "calling-lifecycle-internal": "static-1.66668",
  "calling-lifecycle-messages": "static-1.58962",
  "conditional-properties-service-client": "static-1.3951",
  "crm-links": "static-1.6541",
  "crm-index-visualization-core": "static-1.4437",
  "crm-pipelines-api-client-types": "static-1.4289",
  "customer-data-objects-ui-components": "static-1.13253",
  "customer-data-properties-shared-msw-handlers": "static-1.9812",
  "customer-data-property-utils": "static-1.8319",
  "external-options-client-types": "static-1.4280",
  "formula-editor": "static-1.14641",
  "framework-data-schema-resolvers": "static-1.7115",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.409",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4365",
  "meetings-icalendar-utils-lib": "static-1.857",
  "multi-currency-client-types": "static-1.3845",
  "object-builder-ui-client": "static-1.49465",
  "pipeline-validation-client-types": "static-1.4121",
  "property-value-citations": "static-1.2974",
  "pulse": "static-1.844",
  "smart-property-lib": "static-1.8130",
  "tiered-pricing": "static-1.1820",
  "topics-actions-lib": "static-1.380",
  "ui-addon-form-validation": "static-1.11208",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3283",
  "growth-onboarding-next-action-utils": "static-1.2547",
  "navigation-components": "static-1.18679",
  "onboarding-tours-utils": "static-1.1071",
  "ui-shepherd-tracker": "static-1.7865",
  "ui-universal-auth": "static-1.9246",
  "getting-started-shared-tasks-store": "static-1.18181",
  "hubspotter-http-shared-msw-handlers": "static-1.10483",
  "usage-tracker-session-replay": "static-1.5265",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1178",
  "tanstack-virtual": "static-1.35",
  "audio-components": "static-1.6241",
  "FileManagerCore": "static-1.39798",
  "FileManagerImages": "static-1.37450",
  "video-components": "static-1.13997",
  "foundations-components-legacy": "static-1.1372",
  "purchase-motions-api": "static-1.6257",
  "signup-constants": "static-1.19449",
  "signup-ui-url-generator": "static-2.8280",
  "usage-tracker-public": "static-1.7390",
  "reactive-lib": "static-1.942",
  "simple-logging-lib": "static-1.3271",
  "chatspot-core": "static-1.22492",
  "growth-onboarding-feedback-components": "static-1.6804",
  "cms-field-types": "static-1.5037",
  "content-icons-ui": "static-1.2292",
  "integrations-lib": "static-1.16870",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.491",
  "breeze-engine-core": "static-1.791",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.999",
  "customer-data-tracking": "static-1.7105",
  "products-iframe-lib": "static-1.8453",
  "products-ui-components-shared-msw-handlers": "static-1.10867",
  "restore-request-side-panel-lib": "static-1.1481",
  "onboarding-data-sync-lib": "static-1.2354",
  "hubspot-apollo-cache": "static-1.558",
  "calling-error-reporting": "static-1.31545",
  "shared-worker-versioning": "static-1.11261",
  "calling-usage-tracker": "static-1.6761",
  "voice-sms-access-library": "static-1.1805",
  "conversations-skeleton-state": "static-1.7471",
  "location-customization-utils-lib": "static-1.9943",
  "crm-index-associations-lib": "static-1.6663",
  "framework-data-schema-quick-fetch": "static-1.7020",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10568",
  "redux-toolkit": "static-1.7",
  "sales-views-client-types": "static-1.4479",
  "bark-lib": "static-1.16727",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6111",
  "react-codemirror": "static-1.10862",
  "fdsr-migration-layer": "static-1.234",
  "framework-builder-read-service-client": "static-1.4161",
  "persist-promise": "static-1.3924",
  "event-emitter": "static-1.1174",
  "bend-plugin-pulse": "static-1.347",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.538",
  "fsm": "static-1.3959",
  "policy-lib": "static-1.7015",
  "react-tinymce": "static-1.55827",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10631",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54953",
  "tinymce-plugins": "static-1.58067",
  "tinymce-themes": "static-1.56923",
  "growth-onboarding-next-action-components": "static-1.2575",
  "user-context-client": "static-1.4754",
  "nest": "static-1.460",
  "unified-auth-core-lib": "static-1.1042",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.105",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4755",
  "video-embed": "static-1.36487",
  "social-insights-client-types": "static-1.22661",
  "flux-actions": "static-1.356",
  "integrations-error-boundary-lib": "static-1.14285",
  "integrations-tracking-lib": "static-1.5830",
  "native-integrations-shared-strings": "static-1.7999",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10587",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.760",
  "InboxConnectUtils": "static-4.15410",
  "meetings-connect-utils-lib": "static-1.7829",
  "calling-orchestration-schema": "static-1.36582",
  "crm-record-cards-service-types": "static-1.3735",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16221",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4732",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3261",
  "tinymce-data": "static-1.41038",
  "ui-addon-sales-email": "static-1.5435",
  "layout-dnd-components": "static-1.12856",
  "layout-dnd-utils": "static-1.11831",
  "ui-brand-identity-lib": "static-1.16131",
  "NamespacedHubStyle": "static-2.9203",
  "outpost": "static-1.4385",
  "universal-page-editor-lib": "static-1.3233",
  "adobe-sign-auth-lib": "static-1.305",
  "ads-unified-auth-lib": "static-1.877",
  "google-sheets-integration-lib": "static-1.883",
  "microsoft-drive-integration-lib": "static-1.1016",
  "surveymonkey-integration-lib": "static-1.327",
  "slack-ui-library": "static-1.10618",
  "ContentData": "static-1.69078",
  "layout-data-lib": "static-1.10156",
  "advanced-menus-core": "static-1.15482",
  "advanced-menus-lib": "static-1.12367",
  "ExportDialog": "static-6.10602",
  "ui-memberships-settings-lib": "static-1.34663",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15481",
  "simple-menus-lib": "static-1.16998"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2972",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9880",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26023",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5817",
  "hs-test-utils": "/hs-test-utils/static-1.8247",
  "hub-http": "/hub-http/static-1.6436",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10485",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11703",
  "I18n": "/I18n/static-7.1652",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6671",
  "payment-link-components": "/payment-link-components/static-1.24034",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.13",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7330",
  "quartz-core": "/quartz-core/static-1.6549",
  "quartz-i18n": "/quartz-i18n/static-1.1005",
  "react": "/react/static-7.190",
  "react-colorpicker": "/react-colorpicker/static-2.10429",
  "react-dlb": "/react-dlb/static-1.84",
  "react-utils": "/react-utils/static-2.5495",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20200",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18293",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5840",
  "UIComponents": "/UIComponents/static-3.8649",
  "foundations-assets": "/foundations-assets/static-1.5097",
  "foundations-components": "/foundations-components/static-1.8347",
  "foundations-theming": "/foundations-theming/static-1.4674",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2390",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9849",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1331",
  "quartz-config": "/quartz-config/static-1.1108",
  "quartz-routing": "/quartz-routing/static-1.760",
  "quick-fetch": "/quick-fetch/static-1.4071",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-redact-emails-from-unexpected-route-pathname.6",
  "rpc-client-utils": "/rpc-client-utils/static-1.4884",
  "sanitize-text": "/sanitize-text/static-1.8371",
  "styled-components": "/styled-components/static-2.94",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4978",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9755",
  "usage-tracker": "/usage-tracker/static-1.7579",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5996",
  "usage-tracker-core": "/usage-tracker-core/static-1.7429",
  "video-components-external": "/video-components-external/static-1.11995",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3554",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3607",
  "quartz-webpack": "/quartz-webpack/static-1.3554",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.408",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7906",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8150",
  "laboratory-lib": "/laboratory-lib/static-3.7374",
  "onboarding-scopes": "/onboarding-scopes/static-1.6681",
  "seat-types-lib": "/seat-types-lib/static-1.551",
  "ui-addon-opt": "/ui-addon-opt/static-4.8584",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3358",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.234",
  "ts-schema": "/ts-schema/static-1.4232",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8100",
  "content-media-capture": "/content-media-capture/static-1.5229",
  "cssUtils": "/cssUtils/static-1.857",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10048",
  "file-manager-components": "/file-manager-components/static-1.24299",
  "HubStyle": "/HubStyle/static-2.12010",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "PatternValidationJS": "/PatternValidationJS/static-1.3119",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10108",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11368",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9303",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10484",
  "video-data-lib": "/video-data-lib/static-1.35653",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4541",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6500",
  "customer-data-properties": "/customer-data-properties/static-1.52360",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19063",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5302",
  "onboarding-tours": "/onboarding-tours/static-1.17005",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8321",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3758",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9298",
  "user-context": "/user-context/static-1.5335",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4803",
  "icons": "/icons/static-2.671",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1005",
  "quartz-head": "/quartz-head/static-1.995",
  "quartz-test": "/quartz-test/static-1.1005",
  "quartz-tracking": "/quartz-tracking/static-1.709",
  "trellis-components": "/trellis-components/static-1.2414",
  "ui-fonts": "/ui-fonts/static-1.965",
  "usage-tracker-container": "/usage-tracker-container/static-1.7569",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9648",
  "data-token-picker": "/data-token-picker/static-1.16783",
  "FileManagerLib": "/FileManagerLib/static-1.39939",
  "property-translator": "/property-translator/static-1.5617",
  "atom": "/atom/static-1.5298",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6254",
  "salesImages": "/salesImages/static-1.530",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5830",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.103",
  "ui-images": "/ui-images/static-2.1219",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4616",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2395",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3157",
  "foundations-theming-base": "/foundations-theming-base/static-1.3659",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4977",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5993",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.294",
  "chirp-fetch": "/chirp-fetch/static-1.2110",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4698",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4879",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13033",
  "content-media-compositions": "/content-media-compositions/static-2.17040",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4372",
  "magpie-lib": "/magpie-lib/static-1.5705",
  "magpie-types": "/magpie-types/static-1.5165",
  "media-bridge-lib": "/media-bridge-lib/static-1.19302",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3999",
  "superstore": "/superstore/static-1.4979",
  "feedback-loader": "/feedback-loader/static-1.29698",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9530",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8928",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29168",
  "ContentUtils": "/ContentUtils/static-1.69003",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4647",
  "sassPrefix": "/sassPrefix/static-1.161",
  "react-dnd-compat": "/react-dnd-compat/static-1.4838",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1513",
  "copilot-toolkit": "/copilot-toolkit/static-1.11697",
  "avatar-components": "/avatar-components/static-1.2720",
  "navigation-messaging": "/navigation-messaging/static-1.8006",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8404",
  "commerce-products-lib": "/commerce-products-lib/static-1.10352",
  "crm-message-bus": "/crm-message-bus/static-1.43583",
  "growth-data-modal": "/growth-data-modal/static-1.5784",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5099",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5219",
  "batch-promise": "/batch-promise/static-1.1767",
  "calling-global-api": "/calling-global-api/static-1.65286",
  "calling-internal-common": "/calling-internal-common/static-1.31538",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66668",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58962",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3951",
  "crm-links": "/crm-links/static-1.6541",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4437",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4289",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13253",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9812",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8319",
  "external-options-client-types": "/external-options-client-types/static-1.4280",
  "formula-editor": "/formula-editor/static-1.14641",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7115",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.409",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4365",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.857",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3845",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49465",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4121",
  "property-value-citations": "/property-value-citations/static-1.2974",
  "pulse": "/pulse/static-1.844",
  "smart-property-lib": "/smart-property-lib/static-1.8130",
  "tiered-pricing": "/tiered-pricing/static-1.1820",
  "topics-actions-lib": "/topics-actions-lib/static-1.380",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11208",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3283",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2547",
  "navigation-components": "/navigation-components/static-1.18679",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1071",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7865",
  "ui-universal-auth": "/ui-universal-auth/static-1.9246",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18181",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10483",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5265",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1178",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "audio-components": "/audio-components/static-1.6241",
  "FileManagerCore": "/FileManagerCore/static-1.39798",
  "FileManagerImages": "/FileManagerImages/static-1.37450",
  "video-components": "/video-components/static-1.13997",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1372",
  "purchase-motions-api": "/purchase-motions-api/static-1.6257",
  "signup-constants": "/signup-constants/static-1.19449",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8280",
  "usage-tracker-public": "/usage-tracker-public/static-1.7390",
  "reactive-lib": "/reactive-lib/static-1.942",
  "simple-logging-lib": "/simple-logging-lib/static-1.3271",
  "chatspot-core": "/chatspot-core/static-1.22492",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6804",
  "cms-field-types": "/cms-field-types/static-1.5037",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "integrations-lib": "/integrations-lib/static-1.16870",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.491",
  "breeze-engine-core": "/breeze-engine-core/static-1.791",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.999",
  "customer-data-tracking": "/customer-data-tracking/static-1.7105",
  "products-iframe-lib": "/products-iframe-lib/static-1.8453",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10867",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1481",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2354",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.558",
  "calling-error-reporting": "/calling-error-reporting/static-1.31545",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11261",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6761",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1805",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7471",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9943",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6663",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7020",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10568",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "sales-views-client-types": "/sales-views-client-types/static-1.4479",
  "bark-lib": "/bark-lib/static-1.16727",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6111",
  "react-codemirror": "/react-codemirror/static-1.10862",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.234",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4161",
  "persist-promise": "/persist-promise/static-1.3924",
  "event-emitter": "/event-emitter/static-1.1174",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.347",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.538",
  "fsm": "/fsm/static-1.3959",
  "policy-lib": "/policy-lib/static-1.7015",
  "react-tinymce": "/react-tinymce/static-1.55827",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10631",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54953",
  "tinymce-plugins": "/tinymce-plugins/static-1.58067",
  "tinymce-themes": "/tinymce-themes/static-1.56923",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2575",
  "user-context-client": "/user-context-client/static-1.4754",
  "nest": "/nest/static-1.460",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1042",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.105",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4755",
  "video-embed": "/video-embed/static-1.36487",
  "social-insights-client-types": "/social-insights-client-types/static-1.22661",
  "flux-actions": "/flux-actions/static-1.356",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14285",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5830",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7999",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10587",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.760",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15410",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7829",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36582",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3735",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16221",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4732",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3261",
  "tinymce-data": "/tinymce-data/static-1.41038",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5435",
  "layout-dnd-components": "/layout-dnd-components/static-1.12856",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11831",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16131",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9203",
  "outpost": "/outpost/static-1.4385",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3233",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.305",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.877",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.883",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1016",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.327",
  "slack-ui-library": "/slack-ui-library/static-1.10618",
  "ContentData": "/ContentData/static-1.69078",
  "layout-data-lib": "/layout-data-lib/static-1.10156",
  "advanced-menus-core": "/advanced-menus-core/static-1.15482",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12367",
  "ExportDialog": "/ExportDialog/static-6.10602",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34663",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15481",
  "simple-menus-lib": "/simple-menus-lib/static-1.16998"
}
};
